import React, { Component } from 'react';
import Popup from 'reactjs-popup';
import { Col, Row, Button, Alert, Form } from 'react-bootstrap';
import RoleUtils from '../utils/roleUtils.js';
import CommonUtils from '../utils/siteUtils.js';
import { Loading } from '../components/Loading';
import TimedDisplay from '../components/TimedDisplay';
import ServiceCalls from '../utils/serviceCalls.js';
import '../styles/PopUps.css';

export class SupplierUserPopUp extends Component {

    constructor(props) {
        super(props)
        this.showAlertMessage = this.showAlertMessage.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.postSubmit = this.postSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.buildRoleDisplay = this.buildRoleDisplay.bind(this);
        this.onActiveChange = this.onActiveChange.bind(this);
        this.onRoleSelect = this.onRoleSelect.bind(this);
        this.onLockedChange = this.onLockedChange.bind(this);
        this.state = {
            userData: {},
            isLoading: true,
            hasError: false,
            submitMsg: '',
            submitMsgLvl: '',
            isUpdateComplete: false,
            isPopupOpen: false,
            validated: false,
            userActive: false,
            userLocked: false,  //Shared with Disabled
            lockedControlName: '', //Shared with Disabled
            userRoles: [],
            rolesValidated: true,
            userEmailValid: true,
            userFNValid: true,
            userLNValid: true,
            lockedStatusChange: false,
            isDataFresh: true,
            outdatedMsg: '',
            initialFormData: null,
            currentFormData: null,
            isFormChanged: false,
            lockedStatusChange: false
        }
    }
    componentDidMount() {
        //var roles = (this.props.currentContact) ? this.props.currentContact.roles : [];
        //this.setState({

        //    userRoles: roles,

        //});
    }

    componentDidUpdate(prevProps, prevState) {
        const { isPopupOpen } = this.state;
        const { currentContact, editMode } = this.props;
        if (isPopupOpen !== prevState.isPopupOpen) {
            if (isPopupOpen === true) {
                var isActive = (editMode.toUpperCase() === "ADD") ? true : (currentContact) ? currentContact.active : false;

                var currentRoles = [];
                if (currentContact) {
                    currentRoles = currentContact.roles.map(i => ({ ...i }));
                }
                var isLocked = (editMode.toUpperCase() === "ADD") ? false : (currentContact) ? CommonUtils.determineContactDisabled(currentContact) : false;
                if (!isLocked) {
                    isLocked = (editMode.toUpperCase() === "ADD") ? false : (currentContact) ? CommonUtils.determineContactLocked(currentContact) : false;
                }

                // Initialize form data
                const initialFormData = {
                    email: currentContact ? currentContact.emailAddress.trim() : "",
                    firstName: currentContact ? currentContact.firstName : "",
                    lastName: currentContact ? currentContact.lastName : "",
                    userActive: isActive,
                    userLocked: (isLocked && isLocked.enabled) ? isLocked.enabled : isLocked,
                    userRoles: currentRoles
                };

                this.setState({
                    userActive: isActive,
                    userLocked: (isLocked && isLocked.enabled) ? isLocked.enabled : isLocked,
                    lockedControlName: (currentContact) ? CommonUtils.determineInactiveContactRoleName(currentContact) : "",
                    userRoles: currentRoles,
                    isLoading: false,
                    initialFormData: initialFormData,
                    currentFormData: { ...initialFormData },
                    isFormChanged: false
                });
            }
        }
    }

    resetForm() {
        this.setState({
            submitMsg: '',
            submitMsgLvl: '',
            isUpdateComplete: false,
            isPopupOpen: false,
            validated: false,
            userActive: false,
            userRoles: [],
            rolesValidated: true,
            isLoading: true,
            userEmailValid: true,
            userFNValid: true,
            userLNValid: true,
            lockedStatusChange: false,
            userLocked: false,
            isDataFresh: true,
            outdatedMsg: '',
            initialFormData: null,
            currentFormData: null,
            isFormChanged: false
        });
    }
    postSubmit() {
        this.props.onUserAction();
        this.resetForm();
    }
    showAlertMessage() {
        if (this.state.isUpdateComplete) {
            return (<TimedDisplay delay="3000" callback={this.postSubmit}>
                <Alert variant={this.state.submitMsgLvl}>{this.state.submitMsg}</Alert>
            </TimedDisplay>);
        }
        else {
            return (<></>);
        }
    }
    openPopup() {
        const { currentContact, editMode } = this.props;

        const initialFormData = {
            email: "",
            firstName: "",
            lastName: "",
            userActive: true,
            userLocked: false,
            userRoles: []
        };

        this.setState({
            submitMsg: '',
            submitMsgLvl: '',
            isUpdateComplete: false,
            isPopupOpen: true,
            validated: false,
            userActive: editMode.toUpperCase() === "ADD" ? true : false,
            userlocked: false,
            lockedStatusChange: false,
            userRoles: [],
            rolesValidated: true,
            isLoading: true,
            userEmailValid: true,
            userFNValid: true,
            userLNValid: true,
            initialFormData: initialFormData,
            currentFormData: { ...initialFormData },
            isFormChanged: false
        });
        this.renderForm();
    }

    //US8294730 "Edit" screens to not display the 'Edit' button until something on the form has changed.
    handleFieldChange(field, value) {
        this.setState(prevState => {
            const updatedFormData = { ...prevState.currentFormData, [field]: value };
            let newState = {
                currentFormData: updatedFormData,
                isFormChanged: !this.isFormDataEqual(prevState.initialFormData, updatedFormData)
            };

            // Update corresponding state fields
            if (field === 'userRoles') newState.userRoles = value;
            if (field === 'userActive') newState.userActive = value;
            if (field === 'userLocked') newState.userLocked = value;

            return newState;
        });
    }

    isFormDataEqual(a, b) {
        if (!a || !b) return false;
        if (a.email.toLowerCase() !== b.email.toLowerCase()) return false; //DE1252580 Ignore Case Changes
        if (a.firstName !== b.firstName) return false;
        if (a.lastName !== b.lastName) return false;
        if (a.userActive !== b.userActive) return false;
        if (a.userLocked !== b.userLocked) return false;

        // Normalize roles: treat all-disabled as empty, compare enabled roles
        const normalizeRoles = roles => (roles || []).filter(r => r.enabled).map(r => r.roleId).sort();
        const rolesA = normalizeRoles(a.userRoles);
        const rolesB = normalizeRoles(b.userRoles);
        if (JSON.stringify(rolesA) !== JSON.stringify(rolesB)) return false;

        return true;
    }


    buildContactRecord(form) {
        const { currentCompanyId, currentContact } = this.props;
        var contactId = form.contactId.value;
        var contactStatus = this.state.userActive;
        var contactEMail = form.contactEmail.value.trim();
        var contactLN = form.contactLastName.value.trim();
        var contactFN = form.contactFirstName.value.trim();
        var roles = this.state.userRoles.filter(r => r.enabled === true).map(a => a.roleId);
        var contactData = { supplierId: currentCompanyId, contactId: contactId, roleId: roles, email: contactEMail, firstName: contactFN, lastName: contactLN, enabled: contactStatus };
        return contactData;
    }
    handleSubmit(event) {
        const form = event.currentTarget;
        const { editMode, currentContact, currentCompanyId, spuaEmail, isAdminDisplay } = this.props;
        const { userRoles, userActive, userLocked, lockedStatusChange } = this.state;
        var activeUserRoles = userRoles.filter(r => r.enabled === true);
        event.preventDefault();
        event.stopPropagation();
        var userEmailValid = CommonUtils.validateEmail(form.contactEmail.value.toLowerCase(), this.props.spuaEmail);
      
        //DE864595 - Do not perform email validation on inactive user
        var curContactActive = (currentContact) ? currentContact.active : false;
        var curContactStatus = (currentContact) ? currentContact.status.toLowerCase() : "";
        //3-28-24 Allow roles to be updated on active users even if email is a generic domain
        //US9779507 Email validation for pending users
        if (editMode.toUpperCase() === "EDIT") {
            if (userActive === false && curContactStatus === "inactive") {
                userEmailValid = CommonUtils.validateBasicEmail(form.contactEmail.value.toLowerCase());
            }
            else if (userActive === true && curContactActive === true) {
                userEmailValid = CommonUtils.validateBasicEmail(form.contactEmail.value.toLowerCase());
            }
        }

        var userFNValid = (form.contactFirstName.required === true) ? (form.contactFirstName.value.trim().length > 0) : true;
        var userLNValid = (form.contactLastName.required === true) ? (form.contactLastName.value.trim().length > 0) : true;
        //No need for extra roles if LOCKED status changed  -  Need Extra roles for DISABLED
        var isDisabled = (currentContact) ? CommonUtils.determineContactDisabled(currentContact) : false;
        var rolesValid = ((activeUserRoles.length > 0) || ((userActive === false || lockedStatusChange == true) && !isDisabled));

        var userFNErr = (userFNValid === true) ? "" : (form.contactFirstName.value.trim().length > 0) ? "Maximun length is 50 characters" : "First Name is required";
        var userLNErr = (userLNValid === true) ? "" : (form.contactLastName.value.trim().length > 0) ? "Maximun length is 50 characters" : "Last Name is required";
        var userEmailErr = (userEmailValid === true) ? "" : (form.contactEmail.value.trim().length <= 70) ? "A valid email is required" : "Maximun length is 70 characters";

        if ((form.checkValidity() === false) || (!rolesValid) || (userEmailValid === false) || userFNValid === false || userLNValid === false) {
            this.setState({
                validated: userEmailValid,
                rolesValidated: rolesValid,
                userEmailValid: userEmailValid,
                userFNValid: userFNValid,
                userLNValid: userLNValid,
                userFNError: userFNErr,
                userLNError: userLNErr,
                userEmailError: userEmailErr,
            });
            return;
        }
        // US7053519 --- Stale data check before submit ---
        // Only perform stale data check for EDIT mode
        if (editMode.toUpperCase() === "EDIT" && currentContact) {
            // Use getSupplierContact for all cases - it retrieves all necessary contact information
            ServiceCalls.getSupplierContact(currentContact.contactId, currentCompanyId, isAdminDisplay === true)
                .then((data) => {
                    console.log('Stale data check - received data:', data);
                    let isFresh = true;
                    let outdatedMsg = '';

                    if (!data || !data.contactId) {
                        isFresh = false;
                        outdatedMsg = 'User not found in latest data. Please refresh the page.';
                    } else {
                        // Extract latest roles from suppliers
                        let latestRoles = [];
                        if (data.suppliers && data.suppliers.length > 0) {
                            // Use first supplier's roles
                            latestRoles = data.suppliers[0].contactRoles || [];
                        }

                        const currentRoles = currentContact.roles || [];
                        console.log('latest roles:', latestRoles);
                        console.log('current roles:', currentRoles);

                        const getEnabledRoles = (roles) => (roles || []).filter(r => r.enabled).map(r => r.roleId).sort();
                        const rolesSame = JSON.stringify(getEnabledRoles(latestRoles)) === JSON.stringify(getEnabledRoles(currentRoles));
                        const statusSame = data.profileStatus === currentContact.active;

                        if (!statusSame || !rolesSame) {
                            isFresh = false;
                            outdatedMsg = 'User roles or status have changed. Please refresh the page to get the latest information.';
                        }
                    }

                    if (!isFresh) {
                        this.setState({
                            isDataFresh: false,
                            outdatedMsg: outdatedMsg,
                            isLoading: false
                        });
                        return;
                    }

                    this.performSubmit(form);
                })
                .catch((error) => {
                    console.error('Error during stale data check:', error);
                    this.performSubmit(form);
                });
        } else {
            // For ADD mode, skip stale data check and proceed directly
            this.performSubmit(form);
        }
    }
    performSubmit(form) {
        const { editMode } = this.props;
        var contactRecord = this.buildContactRecord(form);
        this.setState({ isLoading: true, validated: true });

        //Determine Method
        if (editMode.toUpperCase() === "ADD") {
            //CREATE user
            ServiceCalls.addContact(contactRecord).then((data) => {
                //US9284604 Failure messages
                let errorMsg = 'Failed to add user';
                if (!data.isSuccessful && data.message && data.message.toLowerCase().includes('email already exists')) {
                    errorMsg = 'Failed to add user, email already assigned to supplier.';
                } else if (!data.isSuccessful && data.message) {
                    errorMsg = data.message;
                }
                this.setState({
                    submitMsg: (data.isSuccessful) ? `Successfully added user` : errorMsg,
                    submitMsgLvl: (data.isSuccessful) ? 'info' : 'danger',
                    isUpdateComplete: true,
                    validated: true,
                    isLoading: false
                });
            }).catch((error) => {
                console.error('Error adding contact:', error);
                this.setState({
                    submitMsg: 'Failed to add user',
                    submitMsgLvl: 'danger',
                    isUpdateComplete: true,
                    validated: true,
                    isLoading: false
                });
            });
        } else if (editMode.toUpperCase() === "EDIT") {
            //UPDATE user
            ServiceCalls.updateSupplierUser(contactRecord).then((data) => {
                let errorMsg = 'Failed to edit user';
                if (!data.isSuccessful && data.message && data.message.toLowerCase().includes('email already exists')) {
                    errorMsg = 'Failed to update, email already assigned to supplier.';
                } else if (!data.isSuccessful && data.message) {
                    errorMsg = data.message;
                }
                this.setState({
                    submitMsg: (data.isSuccessful) ? `Successfully edited user` : errorMsg,
                    submitMsgLvl: (data.isSuccessful) ? 'info' : 'danger',
                    isUpdateComplete: true,
                    validated: true,
                    isLoading: false
                });
            }).catch((error) => {
                console.error('Error updating contact:', error);
                this.setState({
                    submitMsg: 'Failed to edit user',
                    submitMsgLvl: 'danger',
                    isUpdateComplete: true,
                    validated: true,
                    isLoading: false
                });
            });
        } else {
            console.log('Incorrect mode passed in. No action taken');
            this.setState({
                submitMsg: 'Invalid Mode',
                submitMsgLvl: 'danger',
                isUpdateComplete: true,
                validated: true,
                isLoading: false
            });
        }
       
    }

    onRoleSelect(event) {
        const { userRoles } = this.state;
        const { currentCompanyId, currentUser } = this.props;
        var roleCtl = event.target.id;
        const hasOAdminAccess = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms());
        var statusNotes = (hasOAdminAccess === true) ? "Site_Admin" : "";
        //opposite of current status
        var status = (event.target.checked) //?false: true;
        var roleId = 0;
        switch (roleCtl) {
            case "SIPI":
                roleId = 4;
                break;
            case "LOCKED":
                roleId = 6;
                break;
            case "DISABLED":
                roleId = 7;
                break;
            case "SPI":
                roleId = 9;
                break;
            case "SPENB":
                roleId = 10;
                break;
            case "SPEB":
                roleId = 11;
                break;
            case "SPUA":
                roleId = 3;
                break;
            default:
        }
        var updatedRoles = userRoles.map(i => ({ ...i }));
        RoleUtils.setRoleStatus(roleId, updatedRoles, status, statusNotes);
        // Track form changes
        this.handleFieldChange('userRoles', updatedRoles);
        this.setState(
            {
                userRoles: updatedRoles
            }
        );
    }
    determineRoleStatus(roleId) {
        const { userRoles, userActive, userLocked, lockedStatusChange } = this.state;
        const { editMode/*, currentContact */ } = this.props;
        if (editMode.toUpperCase() === "ADD") {
            return RoleUtils.getRoleStatus(roleId, userRoles);
        }
        else if (editMode.toUpperCase() === "EDIT") {
            //Special Condition for Locked Accounts - Show role as disabled
            var roleStatus = false;
            if (userLocked || lockedStatusChange) {
                roleStatus = userRoles.filter(r => {
                    return r.roleId === roleId
                });
                roleStatus = (roleStatus.length > 0) ? roleStatus[0].enabled : false;
            }
            else {
                roleStatus = (userActive === false) ? false : (userRoles.length > 0) ? RoleUtils.getRoleStatus(roleId, userRoles) : false;
            }
            return roleStatus;
        }
        else {
            return false;
        }
    }
    enableStatusSlider() {
        const { currentContact, currentCompanyId, currentUser } = this.props;
        const { /*validated,*/ userActive, userRoles, userLocked } = this.state;

        var notedRoles = userRoles.filter(r => r.statusNotes !== "" && r.statusNotes !== null);
        var isAdmin = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allAdminPerms());
        var isOAdmin = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms());
        var userAuthorized = (notedRoles.length === 0) || (notedRoles.length > 0 && isAdmin);
        var userStatus = (currentContact && currentContact.status.toLowerCase().includes("active"));
        //11-1-23  Prevent Enabling a Pending user
        var userIsPending = currentContact.status.toLowerCase() === "pending";
        if (userActive === false) {
            //User is Inactive
            if (userIsPending) {
                return false;
            }

            if (notedRoles.length === userRoles.length) {
                return isOAdmin;
            }
            else {
                return isAdmin;
            }
        }
        else {
            //User is Active
            return (userStatus && userAuthorized && userLocked != true);
        }

    }
    buildRoleDisplay() {
        const { userRoles, rolesValidated, validated, userActive, userLocked, lockedStatusChange, lockedControlName } = this.state;
        const { currentUser, editMode, currentCompanyId, currentContact, isSPUAView } = this.props;
        // const hasAdminAccess = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allAdminPerms()); 
        var activeUserRoles = userRoles.filter(r => r.enabled === true);
        var isOAdminAccess = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms()) || currentUser.isOptumAdmin;
        var sipiValue = this.determineRoleStatus(4);  //(userActive===false)?false: (userRoles.length>0) ? RoleUtils.getRoleStatus(4, userRoles): false;
        var spiValue = this.determineRoleStatus(9);   //(userActive === false) ? false : (userRoles.length > 0) ? RoleUtils.getRoleStatus(9, userRoles) : false;
        var spendValue = this.determineRoleStatus(10); //(userActive === false) ? false : (userRoles.length > 0) ? RoleUtils.getRoleStatus(10, userRoles) : false;
        var spuaValue = this.determineRoleStatus(3);  //(userActive === false) ? false : (userRoles.length > 0) ? RoleUtils.getRoleStatus(3, userRoles) : false;
        //Phase 2.2
        var spebValue = this.determineRoleStatus(11); //(userActive === false) ? false : (userRoles.length > 0) ? RoleUtils.getRoleStatus(10, userRoles) : false;
        /*var mode = (editMode.toUpperCase() === "ADD");*/
        var checkEnabled = false;
        if (editMode.toUpperCase() === "ADD") {
            checkEnabled = true;
        }
        else if (editMode.toUpperCase() === "EDIT") {
            checkEnabled = userActive && !(userLocked) && !(lockedStatusChange && lockedControlName === "Locked");
        }
        else {

        }
        var isDisabled = (currentContact) ? CommonUtils.determineContactDisabled(currentContact) : false;
        var isValid = (activeUserRoles.length === 0 && !rolesValidated);
        var spuaDisplay = (isSPUAView) ?
            <Col xs={12} className="roleItem">
                <Form.Check type="checkbox" id="SPUA" >
                    <Form.Check.Input
                        type="checkbox"
                        checked={spuaValue}
                        required={isValid}
                        disabled={!(isOAdminAccess) || userLocked || lockedStatusChange}
                        className="userStatusOption"
                        onChange={this.onRoleSelect}
                    />
                    <Form.Check.Label>Supplier Portal User Admin</Form.Check.Label>
                </Form.Check>
                <Form.Text muted className="roleHelperText">
                    Ability to edit portal access
                </Form.Text>
            </Col>
            : <></>;

        return (
            <div className="roleDisplay">
                <h6>Select all that apply, must select at least one: </h6>
                {spuaDisplay}
                <Col xs={12} className="roleItem">
                    <Form.Check type="checkbox" id="SPEB">
                        <Form.Check.Input
                            type="checkbox"
                            checked={spebValue}
                            disabled={(checkEnabled === false) ? true : (isOAdminAccess) ? (userLocked || (lockedStatusChange && !isDisabled)) : (currentContact) ? RoleUtils.checkSPUAAccessOnRole(11, currentContact.roles) : false}
                            required={isValid}
                            className="userStatusOption"
                            onChange={this.onRoleSelect}
                        />
                        <Form.Check.Label>Supplier Profile Edit-Banking</Form.Check.Label>
                    </Form.Check>
                    <Form.Text muted className="roleHelperText">
                        Ability to update Supplier Profile banking attributes
                    </Form.Text>
                </Col>
                <Col xs={12} className="roleItem">
                    <Form.Check type="checkbox" id="SPENB">
                        <Form.Check.Input
                            type="checkbox"
                            checked={spendValue}
                            disabled={(checkEnabled === false) ? true : (isOAdminAccess) ? (userLocked || (lockedStatusChange && !isDisabled)) : (currentContact) ? RoleUtils.checkSPUAAccessOnRole(10, currentContact.roles) : false}
                            required={isValid}
                            className="userStatusOption"
                            onChange={this.onRoleSelect}
                        />
                        <Form.Check.Label>Supplier Profile Edit-Non Banking</Form.Check.Label>
                    </Form.Check>
                    <Form.Text muted className="roleHelperText">
                        Ability to update Supplier Profile Contact and Address attributes
                    </Form.Text>
                </Col>
                <Col xs={12} className="roleItem">
                    <Form.Check type="checkbox" id="SPI" >
                        <Form.Check.Input
                            type="checkbox"
                            checked={spiValue}
                            required={isValid}
                            disabled={(checkEnabled === false) ? true : (isOAdminAccess) ? (userLocked || (lockedStatusChange && !isDisabled)) : (currentContact) ? RoleUtils.checkSPUAAccessOnRole(9, currentContact.roles) : false}
                            className="userStatusOption"
                            onChange={this.onRoleSelect}
                        />
                        <Form.Check.Label>Supplier Profile Inquire</Form.Check.Label>
                    </Form.Check>
                    <Form.Text muted className="roleHelperText">
                        Ability to view all Supplier Profile attributes
                    </Form.Text>
                </Col>
                <Col xs={12} className="roleItem">
                    <Form.Check type="checkbox" id="SIPI">
                        <Form.Check.Input
                            type="checkbox"
                            required={isValid}
                            checked={sipiValue}
                            disabled={(checkEnabled === false) ? true : (isOAdminAccess) ? (userLocked || (lockedStatusChange && !isDisabled)) : (currentContact) ? RoleUtils.checkSPUAAccessOnRole(4, currentContact.roles) : false}
                            className="userStatusOption"
                            onChange={this.onRoleSelect} />
                        <Form.Check.Label>Supplier Invoice Payment Inquire</Form.Check.Label>
                    </Form.Check>
                    <Form.Text muted className="roleHelperText">
                        Ability to view supplier invoices and payment information
                    </Form.Text>
                </Col>
                {(activeUserRoles.length === 0 && validated && userActive && (lockedStatusChange == false || (lockedStatusChange && isDisabled))) ? <div className="error">At least 1 role must be selected</div> : <></>}
            </div>

        );
    }
    onActiveChange() {
        const { userActive, userRoles } = this.state;
        var newActiveStatus = (!userActive);
        console.log(`Setting user status to ${newActiveStatus}`);
        const newRoles = (newActiveStatus === false) ? [] : userRoles;

        // Track form changes for BOTH userActive and userRoles
        this.setState(prevState => {
            const updatedFormData = {
                ...prevState.currentFormData,
                userActive: newActiveStatus,
                userRoles: newRoles
            };

            return {
                currentFormData: updatedFormData,
                userActive: newActiveStatus,
                userRoles: newRoles,
                isFormChanged: !this.isFormDataEqual(prevState.initialFormData, updatedFormData)
            };
        });
    }
    onLockedChange() {
        const { userLocked, userRoles } = this.state;
        const { currentCompanyId, currentUser, currentContact } = this.props;
        const newLockStatus = !userLocked;
        const hasOAdminAccess = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms());

        console.log(`Setting user locked status to ${newLockStatus}`);
        const updatedRoles = userRoles.map(i => ({ ...i }));
        var roleId = CommonUtils.determineContactDisabled(currentContact) ? 7 : null;
        roleId = CommonUtils.determineContactLocked(currentContact) ? 6 : roleId;
        if (roleId !== null) {
            RoleUtils.setRoleStatus(roleId, updatedRoles, newLockStatus, '');
            // Track form changes
            this.handleFieldChange('userRoles', updatedRoles);
            this.handleFieldChange('userLocked', newLockStatus);
            this.setState({
                userRoles: updatedRoles,
                userLocked: newLockStatus,
                lockedStatusChange: true,
            });
        }
    }
    //determin if Email is editable
    isEmailEditable() {
        const { currentContact, editMode } = this.props;
        if (editMode.toUpperCase() === "ADD") {
            return true;
        }
        var userHasSPUA = currentContact.roles.find(({ roleId }) => roleId === 3);
        //user is Either Active or Pending AND user does not have the SPUA role
        //6-14 removed Active from being Editable - currentContact.status.toLowerCase() === "active"
        if ((currentContact.status.toLowerCase() === "pending") && (userHasSPUA === undefined)) {
            //Allow editing
            return true;
        } else {
            //No Editing
            return false;
        }
    }
    renderForm() {
        const { currentContact, currentCompanyId, currentUser, editMode, isSPUAView, isAdminDisplay } = this.props;
        const { validated, userActive, userLocked, isLoading, submitMsg, userEmailValid, userFNValid, userLNValid, userEmailError, userFNError, userLNError, lockedControlName, lockedStatusChange, isDataFresh, outdatedMsg, currentFormData, isFormChanged } = this.state;
        const hasOAdminAccess = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms()) || isAdminDisplay;
        var enableControls = false;
        //  var supplierRoles = (currentContact) ? currentContact.roles.slice(0) : [];
        //var notedRoles = userRoles.filter(r => r.statusNotes !== "" && r.statusNotes!==null);
        //var adminDisabled = notedRoles.length !== userRoles.length;

        // Stale data warning
        if (isDataFresh === false && outdatedMsg) {
            return (
                <div className="vContactPopupArea">
                    <Alert variant="warning">{outdatedMsg}</Alert>
                    <Button variant="primary" onClick={this.resetForm}>Close</Button>
                </div>
            );
        }

        if (!currentFormData) {
            return <Loading />;
        }

        if (isSPUAView) {
            //DE1010101 - For SPUA user do not allow OA to unlock and disable user
            enableControls = (!userLocked && !lockedStatusChange);
        }
        else if (editMode.toUpperCase() === "ADD") {
            //Must be Optum or Supplier Admin
            var canUpdate = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allAdminPerms());
            enableControls = canUpdate;
        }
        else {
            //Must be Optum Admin if Roles contain notes
            //6-20 Allow all admins to be able to deactivate a user
            //OLD var canUpdate = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms());
            //var canUpdate = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allAdminPerms());
            //var userAuthorized = (notedRoles.length === 0) || (notedRoles.length > 0 && canUpdate);
            // var userStatus = (currentContact && currentContact.status.toLowerCase().includes("active"));
            enableControls = this.enableStatusSlider();//(userStatus && userAuthorized);
        }

        var OAdminRequiredElem = (hasOAdminAccess) ? <></> : <span className="required">*</span>;
        var canReEnableInactive = (hasOAdminAccess && lockedControlName === "Locked")  //ADMIN PAGED LOCKED
            || (RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allAdminPerms()) && lockedControlName === "Disabled")  //SPUA USE
            || (hasOAdminAccess && lockedControlName === "Disabled");   //ADMIN PAGED DISABLED 

        var activeRoles = this.state.userRoles.filter(r => r.enabled === true);
        const notActiveMsg = (editMode.toUpperCase() === "ADD") ? <></> : (activeRoles.length > 0 && !userActive)
            ? <Col><div className="error">Upon inactivation of user, role(s) will be disabled.</div></Col>
            : <></>;
        const enabledBtn = (isSPUAView)
            ? <Form.Group as={Col} className="mb-2" controlId="userEnabled">
                <Form.Label>Active</Form.Label>
                <Form.Switch
                    type="switch"
                    id="contactStatus"
                    className="userStatusOption"
                    disabled={!(hasOAdminAccess) || (userLocked) || (lockedStatusChange)}
                    checked={userActive}
                    onChange={this.onActiveChange}
                />
            </Form.Group>
            : (editMode.toUpperCase() === "EDIT")
                ?
                <Form.Group as={Col} className="mb-2" controlId="userEnabled">
                    <Form.Label>Active</Form.Label>
                    <Form.Check
                        type="switch"
                        id="contactStatus"
                        className="userStatusOption"
                        disabled={(enableControls === false)}
                        checked={userActive}
                        onChange={this.onActiveChange}
                    />
                </Form.Group>
                : <Form.Control
                    type="hidden"
                    required
                    placeholder=""
                    disabled={(enableControls === false)}
                    id="contactStatus"
                    defaultValue="on" />;
        //US7652820 - LOCKED ACCOUNT
        const lockedBtn = (isSPUAView)
            ? (userLocked || lockedStatusChange)
                ? <Form.Group as={Col} className="mb-2" controlId="LOCKED" >
                    <Form.Label>{lockedControlName}</Form.Label>
                    <Form.Switch
                        type="switch"
                        id="contactLocked"
                        className="userStatusOption"
                        disabled={(userLocked === false) || !(canReEnableInactive)}
                        checked={userLocked}
                        onChange={this.onLockedChange}
                    />
                </Form.Group>
                : <></>
            : (editMode.toUpperCase() === "EDIT")
                ? (userLocked || lockedStatusChange)
                    ? <Form.Group as={Col} className="mb-2" controlId="LOCKED">
                        <Form.Label>{lockedControlName}</Form.Label>
                        <Form.Check
                            type="switch"
                            id="contactLocked"
                            className="userStatusOption"
                            disabled={(userLocked === false) || !(canReEnableInactive)}
                            checked={userLocked}
                            onChange={this.onLockedChange}
                        />
                    </Form.Group >
                    : <></>
                : <></>;
        //Do not show roles for Admin functionality
        //Check if prop exists, if not, will be false
        const adminDisplayProp = (typeof isAdminDisplay === "undefined") ? false : isAdminDisplay;
        const roleDisplay = this.buildRoleDisplay();

        const actionBtn = (editMode.toUpperCase() === "EDIT")
            ? (isFormChanged
                ? <Button variant="primary" className="right userActionBtn" type="submit">Edit</Button>
                : <></>)
            : <Button variant="primary" className="right userActionBtn" type="submit">Add</Button>;
        var userIdValue = (currentContact) ? currentContact.contactId : 0;
        var userEmailValue = (currentContact) ? currentContact.emailAddress.trim() : "";
        var userLNValue = (currentContact) ? currentContact.lastName : "";
        var userFNValue = (currentContact) ? currentContact.firstName : "";
        var editDisabledControl = (editMode.toUpperCase() === "EDIT");
        var disabledEmail = (isSPUAView) ? true : !(this.isEmailEditable());
        return (
            <div className="vContactPopupArea">
                <h4 className="vContactPopupHdr">{editMode} User</h4>
                <Form noValidate validated={validated} onSubmit={this.handleSubmit}>
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactId"
                        defaultValue={userIdValue} />

                    <Row className="mb-12">
                        <Form.Group as={Col} className="mb-3" controlId="contactEmail">
                            <Form.Label>Email<span className="required">*</span></Form.Label>
                            <Form.Control
                                type="email"
                                required
                                maxLength="70"
                                isInvalid={!userEmailValid}
                                disabled={disabledEmail}
                                placeholder="Enter email address"
                                value={currentFormData.email}
                                onChange={(e) => this.handleFieldChange('email', e.target.value)}
                                title={userEmailValue}
                            />
                            <Form.Control.Feedback type="invalid">
                                {userEmailError}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-12">
                        <Form.Group as={Col} className="mb-3" controlId="contactLastName">
                            <Form.Label>Last Name {OAdminRequiredElem}</Form.Label>
                            <Form.Control
                                type="text"
                                required={!hasOAdminAccess}
                                isInvalid={(hasOAdminAccess === false && userLNValid === false)}
                                maxLength="50"
                                disabled={editDisabledControl}
                                placeholder="Enter last name"
                                value={currentFormData.lastName}
                                onChange={(e) => this.handleFieldChange('lastName', e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid">
                                {userLNError}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-12">
                        <Form.Group as={Col} className="mb-3" controlId="contactFirstName">
                            <Form.Label>First Name {OAdminRequiredElem}</Form.Label>
                            <Form.Control
                                type="text"
                                required={!hasOAdminAccess}
                                maxLength="50"
                                isInvalid={(hasOAdminAccess === false && userFNValid === false)}
                                disabled={editDisabledControl}
                                placeholder="Enter first name"
                                value={currentFormData.firstName}
                                onChange={(e) => this.handleFieldChange('firstName', e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid">
                                {userFNError}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-12">
                        {enabledBtn}
                        <Col className="mb-8">&nbsp;</Col>
                        {lockedBtn}
                    </Row>
                    <Row className="mb-12">
                        {roleDisplay}
                    </Row>
                    <Row className="mb-12">
                        {notActiveMsg}
                    </Row>
                    {(isLoading) ? <Loading /> : (submitMsg) ?
                        this.showAlertMessage()
                        :
                        <Row className="mb-12">
                            <Col>
                                {actionBtn}
                                <Button variant="primary" className="right userActionBtn" onClick={this.resetForm}>Cancel</Button>
                            </Col>
                        </Row>
                    }
                </Form>
            </div>
        );
    }

    render() {
        const { isPopupOpen } = this.state;
        var btnName = (this.props.editMode.toUpperCase() === "ADD") ? "Add User" : this.props.editMode;
        return (
            (!isPopupOpen) ? <Button className={this.props.btnClass} onClick={() => this.openPopup()}>{btnName}</Button> :
                <Popup open={isPopupOpen} modal closeOnDocumentClick={false} closeOnEscape={true} onClose={this.resetForm}>
                    {close => (this.renderForm())}
                </Popup>
        );
    }
}
